<script setup lang="ts">
// Footer obrigatório com versículo do dia + "Para a glória de Deus"
// Lista curada pelo Alex — critério: salvação, graça, esperança, evangelização

const VERSICULOS = [
  { texto: 'Porque Deus amou o mundo de tal maneira que deu o seu Filho unigênito, para que todo aquele que nele crê não pereça, mas tenha a vida eterna.', referencia: 'João 3:16' },
  { texto: 'Jesus disse: Eu sou o caminho, e a verdade, e a vida. Ninguém vem ao Pai senão por mim.', referencia: 'João 14:6' },
  { texto: 'Porque pela graça sois salvos, por meio da fé; e isso não vem de vós; é dom de Deus.', referencia: 'Efésios 2:8' },
  { texto: 'Se confessarmos os nossos pecados, ele é fiel e justo para nos perdoar os pecados e nos purificar de toda injustiça.', referencia: '1 João 1:9' },
  { texto: 'Vinde a mim, todos os que estais cansados e oprimidos, e eu vos aliviarei.', referencia: 'Mateus 11:28' },
  { texto: 'Porque o salário do pecado é a morte, mas o dom gratuito de Deus é a vida eterna em Cristo Jesus nosso Senhor.', referencia: 'Romanos 6:23' },
  { texto: 'Mas Deus prova o seu amor para conosco pelo fato de ter Cristo morrido por nós, sendo nós ainda pecadores.', referencia: 'Romanos 5:8' },
  { texto: 'Arrependei-vos e sede batizados cada um de vós em nome de Jesus Cristo para remissão dos vossos pecados.', referencia: 'Atos 2:38' },
  { texto: 'O ladrão vem apenas para roubar, matar e destruir; eu vim para que tenham vida e a tenham em abundância.', referencia: 'João 10:10' },
  { texto: 'Porque todo aquele que invocar o nome do Senhor será salvo.', referencia: 'Romanos 10:13' },
  { texto: 'Sede fortes e corajosos. Não tenhais medo, nem vos assusteis, porque o Senhor, o vosso Deus, vai convosco.', referencia: 'Deuteronômio 31:6' },
  { texto: 'O Senhor é o meu pastor e nada me faltará.', referencia: 'Salmos 23:1' },
];

function getVersiculoDoDia() {
  const hoje = new Date();
  const diaDoAno = Math.floor((hoje.getTime() - new Date(hoje.getFullYear(), 0, 0).getTime()) / 86400000);
  return VERSICULOS[diaDoAno % VERSICULOS.length]!;
}

const v = getVersiculoDoDia();
</script>

<template>
  <footer class="mt-auto border-t border-gray-800 py-6 px-4">
    <div class="max-w-screen-xl mx-auto text-center space-y-2">
      <p class="text-xs text-gray-600 italic">"{{ v.texto }}"</p>
      <p class="text-xs text-gray-700">— {{ v.referencia }}</p>
      <p class="text-xs text-gray-700 mt-3">Para a glória de Deus</p>
    </div>
  </footer>
</template>
